import { render } from "./faq2.vue?vue&type=template&id=f98d2938"
import script from "./faq2.vue?vue&type=script&lang=js"
export * from "./faq2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__